/* tslint:disable:no-trailing-whitespace import-spacing no-inferrable-types typedef-whitespace variable-name align */

import {ProjectElement}          from './project.element';
import {ProjectElementType}      from './project.element.type';
import { BlobType }              from '../blob';

import { Project }               from '../project';

import {ProjectElementFactoryDecorator} from "@/models/project/project.element.factory.decorator";
import {FileBrowserMetadata} from "@/screens/ide/file.browser.metadata";

/**
 *
 * @class OperationalMeasuresElement
 *
 * root element for all the operational measures in a project.
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      January 2022
 *
 */
@ProjectElementFactoryDecorator('OperationalMeasuresElement')
export class OperationalMeasuresElement extends ProjectElement {

  public actionKeys: string[] = [
    'createmeasure',
    'viewinbrowser'
  ];

  /** standard constructor */
  constructor(
    project: Project,
    id: string,
    parent: ProjectElement,
    label: string = 'Operational Measures',
    publish: boolean = false
  ) {

    super(project, id, ProjectElementType.OperationalMeasures);

    this._acceptsElements.push(ProjectElementType.SimulationGroup);
    this._acceptsBlobs.push(BlobType.None);

    this._enabled     = true;
    this._label       = label;
    this._icon        = 'fas fa-cogs';
    this._elementKind = 'Operational Measures';

    if (parent) {

      this._project.addElement(this, parent, publish);
    }

  }

  /** is this element deletable? */
  public isDeletable() : boolean {

    return false;
  }

  /**
   * subclasses must add their menu item definition(s) to the given action set,
   * in jquery-contextmenu fashion.
   *
   * @param actionSet any
   *
   */
  public actions(actionSet: any): any {

    actionSet.newmeasures = {
      name: 'New Historic Stringline',
      icon: 'fas fa-plus',
      disabled: this.isBusy()
    };

    actionSet.newregression = {
      name: 'New Regression',
      icon: 'fas fa-plus',
      disabled: this.isBusy()
    };

    actionSet.newbatchsummary = {
      name: 'New Batch Summary',
      icon: 'fas fa-plus',
      disabled: this.isBusy()
    };

    actionSet.viewinbrowser = {
      name: 'Folder Of',
      icon: 'fas fa-list',
      disabled: false
    };

    return actionSet;

  }


  /** test if this element accepts the given action */
  public acceptsAction(key: string): boolean {

    if (!!this.actionKeys.find(x => x === key)) {

      return true;
    }

    return this._parent.acceptsAction(key);
  }

  /** subclasses must implement their own actions */
  public action(key: string, selection: ProjectElement[]) {

    switch (key) {

      case 'viewinbrowser': {

        this._project.services.ide.launchWindow(FileBrowserMetadata.build(this._blobKey, this._blobKey));

        return;
      }
    }

    return super.action(key, selection);
  }

}
